import React, { useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import Block from '../Block'
import DynamicList from '../DynamicList'
import { calculateTransactionCost } from '../../model/calculator/transactions'
import { CalculatorContext } from '../Context/CalculatorContext'

const TransactionBlocks = ({ cost, setCost, blocks, setBlocks }) => {
    const { currency } = useContext(CalculatorContext)

    const handleSetBlocks = (callback) => {
        const next = { ...blocks }
        callback(next)
        setBlocks(next)
    }

    useEffect(() => {
        setCost(calculateTransactionCost(blocks))
    }, [blocks, currency, setCost])

    return (
        <div>
            {Object.entries(blocks)
                .map(([key, { items, suffix }]) => (
                    <Block
                        cost={
                            cost.blocks[suffix || key]
                                ? cost.blocks[suffix || key].total
                                : 0
                        }
                        suffix={suffix}
                        setSuffix={(suffix) =>
                            handleSetBlocks(
                                (next) => (next[key].suffix = suffix)
                            )
                        }
                        currency={currency}
                        title="Estimated usage"
                        startOpen={true}
                        key={key}
                    >
                        <DynamicList
                            items={items}
                            onChange={(items) =>
                                handleSetBlocks(
                                    (next) => (next[key].items = items)
                                )
                            }
                            onRemove={() =>
                                handleSetBlocks((next) => {
                                    delete next[key]
                                })
                            }
                        />
                    </Block>
                ))
                .reduceRight((acc, item) => {
                    acc.push(item)
                    return acc
                }, [])}
        </div>
    )
}

TransactionBlocks.propTypes = {
    cost: PropTypes.shape({
        total: PropTypes.number,
        sources: PropTypes.objectOf(PropTypes.number),
        groups: PropTypes.object
    }),
    setCost: PropTypes.func.isRequired
}

export default TransactionBlocks
